import React from 'react'

import { Flex } from '@chatterbug/aaron'

const ActionsList = ({ children }) => {
  return (
    <Flex lineHeight="1" alignItems="center">
      {children}
    </Flex>
  )
}

export default ActionsList
